/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Menu_Intelligence_DescInputs */



/**
* | output |
* | --- |
* | "What moved in your server, and what your events did" |
*
* @param {Products_Menu_Intelligence_DescInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_menu_intelligence_desc = /** @type {((inputs?: Products_Menu_Intelligence_DescInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Menu_Intelligence_DescInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Что изменилось на сервере и что дали ваши события")
	return /** @type {LocalizedString} */ ("What moved in your server, and what your events did")
});